import React from "react";
import { Card, CardBody } from "reactstrap";
import Avatar from "../../../../../base/components/Avatar";
import { SEX_LABELS } from "../../../Fitness/WorkoutDetails/components/WorkoutDescriptionTable/constants";

const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

const InfoRow = ({ label, value, details, isLast }) => (
  <div
    className={`d-flex justify-content-between align-items-center py-2${
      !isLast ? " border-bottom" : ""
    }`}
    style={{ minHeight: 40 }}
  >
    <span className="text-muted small">{label}</span>
    <span className="fw-semibold fs-6 text-end">
      {value}
      {details !== undefined && details !== null && (
        <small className="text-secondary ms-2">({details})</small>
      )}
    </span>
  </div>
);

const UserSummaryCard = ({
  user,
  labs,
  recommendations,
  questionnaires,
  testKits,
  title
}) => (
  <Card
    className="mx-auto my-3 w-100"
    style={{
      maxWidth: 370,
      minWidth: 270,
      margin: "0 32px",
      boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
      borderRadius: 16
    }}
  >
    <CardBody style={{ padding: "2rem 1.5rem" }}>
      <div className="fw-bold fs-5 mb-4 text-center">{title}</div>
      <div className="d-flex align-items-center mb-4">
        <Avatar
          avatar={user?.avatar}
          firstName={user?.firstName}
          lastName={user?.lastName}
          className="table-item-avatar"
          style={{ width: 52, height: 52, fontSize: 24 }}
        />
        <div className="ms-3">
          <div className="fw-bold fs-6">
            {user?.firstName || "null"} {user?.lastName || "null"}
          </div>
          <div className="text-muted small">{user?.email}</div>
        </div>
      </div>
      <div className="mb-2">
        <InfoRow label="User ID" value={user?.id} />
        <InfoRow label="Joined Date" value={formatDate(user?.createdAt)} />
        <InfoRow
          label="Last Active"
          value={formatDate(user?.additionalField?.lastActiveDate)}
        />
        <InfoRow
          label="Gender | DOB"
          value={`${SEX_LABELS[user?.additionalField?.sex] || "N/A"} | ${
            formatDate(user?.additionalField?.dateOfBirth) || "N/A"
          }`}
        />
        <InfoRow
          label="# Test Kits"
          value={Array.isArray(testKits) ? testKits.length : 0}
          details={
            Array.isArray(testKits)
              ? testKits
                  .map(kit => kit.sampleCode)
                  .filter(Boolean)
                  .join(", ") || undefined
              : undefined
          }
        />
        <InfoRow
          label="# Lab Results"
          value={Array.isArray(labs) ? labs.length : 0}
          details={
            Array.isArray(labs)
              ? (() => {
                  const dates = labs
                    .map(lab => lab.resultFileAt)
                    .filter(Boolean)
                    .map(date => new Date(date));
                  if (dates.length === 0) return undefined;
                  const latest = new Date(Math.max(...dates));
                  return `Latest: ${formatDate(latest)}`;
                })()
              : undefined
          }
        />
        <InfoRow
          label="# Recommendations"
          value={Array.isArray(recommendations) ? recommendations.length : 0}
        />
        <InfoRow
          label="# Questionnaires"
          value={Array.isArray(questionnaires) ? questionnaires.length : 0}
          isLast={true}
        />
      </div>
    </CardBody>
  </Card>
);

export default UserSummaryCard;
